import React from 'react'

interface HomeProps {
  disabled?: boolean
  onChoose: () => void
  onHistory: () => void
  onSettings: () => void
  onRefresh: () => void
  onChat: () => void
}

export default function Home({ disabled, onChoose, onHistory, onSettings, onRefresh, onChat }: HomeProps) {
  return (
    <div>
      <div className="menu">
        <div className="card big">Welcome — log what you do and eat</div>
        <button className="menu-btn" disabled={disabled} onClick={onChoose}>
          Log actions
        </button>
        <button className="menu-btn" disabled={disabled} onClick={onChat}>
          Ask Tracker AI
        </button>
        <button className="menu-btn secondary" disabled={disabled} onClick={onHistory}>
          History
        </button>
        <button className="menu-btn secondary" disabled={disabled} onClick={onSettings}>
          Settings
        </button>
        <button className="menu-btn secondary" disabled={disabled} onClick={onRefresh}>
          Refresh
        </button>
      </div>
    </div>
  )
}
